export const STATIC = 1
export const DYNAMIC = 2
export const DYNAMIC_REMOTE_LIST = 3

export const CONTACTS_STRING_KEYS = ['all', 'unanswered', 'unassigned', 'my-contacts', 'new-leads']
